import { Controller } from '@hotwired/stimulus'

// Live badge preview while editing file tag color on the settings form.
export default class extends Controller {
  static targets = ['badge']
  static values = { input: String }

  connect() {
    this._input = document.querySelector(this.inputValue)
    if (!this._input) return

    this._onInput = () => this._refresh()
    this._input.addEventListener('input', this._onInput)
    this._refresh()
  }

  disconnect() {
    this._input?.removeEventListener('input', this._onInput)
  }

  _refresh() {
    const color = this._input?.value || '#3498db'
    this.badgeTarget.style.backgroundColor = color
    this.badgeTarget.style.color = this._contrastColor(color)
  }

  _contrastColor(hex) {
    const h = hex.replace('#', '')
    const r = parseInt(h.substring(0, 2), 16)
    const g = parseInt(h.substring(2, 4), 16)
    const b = parseInt(h.substring(4, 6), 16)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255.0
    return luminance > 0.55 ? '#333' : '#fff'
  }
}
